import React, { useState } from 'react';
import { TextField, IconButton, Button, Typography, Slider, Tooltip } from '@material-ui/core';
import {
  ZoomIn,
  ZoomOut,
  NavigateBefore,
  NavigateNext,
  FastForward as FastForwardIcon,
  FastRewind as FastRewindIcon,
  RotateRight as RotateRightIcon,
  RotateLeft as RotateLeftIcon,
  GetApp
} from '@material-ui/icons';
import PDFPrinter from 'src/components/PDF/PDFPrinter/PDFPrinter';
import useStyles from 'src/components/PDF/PDFControlPanel/PDFControlPanelStyles';

const PDFControlPanel = ({
  rotateClockwise,
  rotateCounterclockwise,
  numPages,
  pageNumber,
  setPageNumber,
  scale,
  setScale,
  pdfUrl,
  isOnMediaPage,
  downloadLink,
}) => {
  const classes = useStyles(isOnMediaPage);

  const [goToPageInput, setGoToPageInput] = useState('');

  const handleZoomIn = () => {
    setScale((scale) => scale + 0.1);
  };

  const handleZoomOut = () => {
    if (scale > 0.2) {
      setScale((scale) => scale - 0.1);
    }
  };

  const handleGoToPage = () => {
    const pageNum = parseInt(goToPageInput);
    if (!isNaN(pageNum) && pageNum > 0 && pageNum <= numPages) {
      setPageNumber(pageNum);
      setGoToPageInput('');
    }
  };

  const handleNextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber((pageNumber) => pageNumber + 1);
    }
  };

  const handlePreviousPage = () => {
    if (pageNumber > 1) {
      setPageNumber((pageNumber) => pageNumber - 1);
    }
  };

  const handleFastRewind = () => {
    if (pageNumber > 10) {
      setPageNumber((pageNumber) => pageNumber - 10);
    }
  };

  const handleFastForward = () => {
    if (pageNumber < numPages - 10) {
      setPageNumber((pageNumber) => pageNumber + 10);
    }
  };
  const handleFirstPage = () => {
    if (pageNumber !== 1) {
      setPageNumber(1);
    }
  };
  const handleLastPage = () => {
    if (pageNumber !== numPages) {
      setPageNumber(numPages);
    }
  };

  const handleDownloadPDF = () => {

    // Use fetch API to download the file as a blob
    fetch(downloadLink)
      .then(response => response.blob())
      .then(blob => {
        // Create a blob URL
        const blobUrl = URL.createObjectURL(blob);

        // Create a hidden anchor element to force download
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', 'document.pdf'); // Set suggested filename
        // Don't add to DOM to avoid any navigation
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        // Release the blob URL
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
      })
      .catch(error => {
        console.error('Error downloading PDF:', error);
      });
  };
  return (
    <div className={classes.controlPanelWrapper}>
      <div className={classes.leftSidePanel}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <IconButton disabled={pageNumber <= 10} onClick={handleFastRewind} color="primary">
            <FastRewindIcon />
          </IconButton>
          <IconButton disabled={pageNumber === 1} onClick={handlePreviousPage} color="primary">
            <NavigateBefore />
          </IconButton>
          <Typography className={classes.pageNumberText}>
            Page {pageNumber} of {numPages}
          </Typography>
          <IconButton disabled={pageNumber === numPages} onClick={handleNextPage} color="primary">
            <NavigateNext />
          </IconButton>
          <IconButton disabled={pageNumber >= numPages - 9} onClick={handleFastForward} color="primary">
            <FastForwardIcon />
          </IconButton>
          {/* <Button
            className={classes.firstButton}
            disabled={pageNumber === 1}
            variant="contained"
            color="primary"
            onClick={handleFirstPage}>
            First Page
          </Button>
          <Button
            className={classes.lastButton}
            disabled={pageNumber === numPages}
            variant="contained"
            color="primary"
            onClick={handleLastPage}>
            Last Page
          </Button> */}
          {/* <TextField
            className={classes.pdfTextFields}
            onKeyDown={(e) => e.key === 'Enter' && handleGoToPage()}
            variant="outlined"
            size="small"
            placeholder="Go to page"
            value={goToPageInput}
            onChange={(e) => setGoToPageInput(e.target.value)}
            style={{ marginRight: '10px', width: '100px' }}
          />
          <Button
            className={classes.goButton}
            disabled={goToPageInput === '' || isNaN(goToPageInput)}
            variant="contained"
            color="primary"
            onClick={handleGoToPage}>
            Go
          </Button> */}
        </div>
        <div className={classes.rightSidePanel}>
          <IconButton className={classes.zoomOutButton} onClick={handleZoomOut} color="primary" size="medium">
            <ZoomOut fontSize="medium" />
          </IconButton>
          <div className={classes.scaleAndSlider}>
            <Typography variant="caption" className={classes.zoomNumber}>{(scale * 100).toFixed()}%</Typography>
            <Slider
              value={scale * 100}
              onChange={(e, newValue) => setScale(newValue / 100)}
              min={20}
              max={200}
              style={{ width: '130px', margin: '0 8px' }}
            />
          </div>
          <IconButton className={classes.zoomInButton} onClick={handleZoomIn} color="primary" size="medium">
            <ZoomIn fontSize="medium" />
          </IconButton>
          <Tooltip title="Rotate Clockwise">
            <IconButton onClick={rotateClockwise} color="primary" size="medium">
              <RotateRightIcon fontSize="medium" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Rotate Counterclockwise">
            <IconButton onClick={rotateCounterclockwise} color="primary" size="medium">
              <RotateLeftIcon fontSize="medium" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download PDF">
            <IconButton onClick={handleDownloadPDF} color="primary">
              <GetApp />
            </IconButton>
          </Tooltip>

          <div className={classes.printPDF}>
            <PDFPrinter pdfUrl={pdfUrl} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default PDFControlPanel;
